// import Saga functions
import { all, call, takeEvery, put } from "redux-saga/effects";

// Import actionType
import {
  GET_COMPANY_TO_USER_LIST,
  SWITCH_COMPANY,
  GET_COMPANY_USER_INVITATIONS,
  SEND_EMAIL_INVITATION,
  GET_JOIN_COMPANY_INVITATION_LIST,
  ACCEPT_OR_DECLINE_INVITATION_TO_JOIN_COMPANY,
  GET_COMPANY_TEAM_MEMBERS_LIST,
  GET_COMPANY_DETAILS,
  UPDATE_COMPANY_DETAILS,
  GET_USER_AVAILABLE_MENU,
  GET_USER_AVAILABLE_DASHBOARD,
  MAP_DASHBOARD_AND_MENU_TO_USER,
  GET_COMPANY_TO_USER_LIST_TEAM,
  UPDATE_COMPANY_TO_USER_TEAM,
  CREATE_COMPANY_TO_USER,
  DELETE_COMPANY_TO_USER,
  COMPANY_TO_USER_LOCK_USER,
  COMPANY_TO_USER_UNLOCK_USER,
  COMPANY_TO_USER_RESET_PASSWORD,
  COMPANY_TO_USER_UPDATE_SUBSCRIPTION_LICENCE_AND_SECURITY,
  GET_COMPANY_TO_USER_DATA,
} from "./actionType";

// Import action

import {
  getCompanyToUserListSuccess,
  getCompanyToUserListFailure,
  switchCompanySuccess,
  switchCompanyFailure,
  getCompanyUserInvitationsSuccess,
  getCompanyUserInvitationsFailure,
  sendEmailInvitationSuccess,
  sendEmailInvitationFailure,
  getJoinCompanyInvitationListSuccess,
  getJoinCompanyInvitationListFailure,
  acceptOrDeclineInvitationToJoinCompanySuccess,
  acceptOrDeclineInvitationToJoinCompanyFailure,
  getCompanyTeamMembersListSuccess,
  getCompanyTeamMembersListFailure,
  getCompanyDetailsSuccess,
  getCompanyDetailsFailure,
  updateCompanyDetailsSuccess,
  updateCompanyDetailsFailure,
  getUserAvailableMenuSuccess,
  getUserAvailableMenuFailure,
  getUserAvailableDashboardSuccess,
  getUserAvailableDashboardFailure,
  mapDashboardAndMenuToUserSuccess,
  mapDashboardAndMenuToUserFailure,
  getCompanyToUserListTeamSuccess,
  getCompanyToUserListTeamFailure,
  updateCompanyToUserTeamSuccess,
  updateCompanyToUserTeamFailure,
  createCompanyToUserSuccess,
  createCompanyToUserFailure,
  deleteCompanyToUserSuccess,
  deleteCompanyToUserFailure,
  companyToUserLockUserSuccess,
  companyToUserLockUserFailure,
  companyToUserUnlockUserSuccess,
  companyToUserUnlockUserFailure,
  companyToUserResetPasswordSuccess,
  companyToUserResetPasswordFailure,
  companyToUserUpdateSubscriptionLicenceAndSecuritySuccess,
  companyToUserUpdateSubscriptionLicenceAndSecurityFailure,
  getCompanyToUserDataSuccess,
  getCompanyToUserDataFailure,
} from "./action";

// Import api call
import {
  getCompanyToUserListApiCall,
  switchCompanyApiCall,
  getCompanyUserInvitationsApiCall,
  sendEmailInvitationApiCall,
  getJoinCompanyInvitationListApiCall,
  acceptOrDeclineInvitationToJoinCompanyApiCall,
  getCompanyTeamMembersListApiCall,
  getCompanyDetailsApiCall,
  updateCompanyDetailsApiCall,
  getUserAvailableMenuApiCall,
  getUserAvailableDashboardApiCall,
  mapDashboardAndMenuToUserApiCall,
  getCompanyToUserListTeamApiCall,
  updateCompanyToUserTeamApiCall,
  createCompanyToUserApiCall,
  deleteCompanyToUserApiCall,
  companyToUserLockUserApiCall,
  companyToUserUnlockUserApiCall,
  companyToUserResetPasswordApiCall,
  companyToUserUpdateSubscriptionLicenceAndSecurityApiCall,
  getCompanyToUserDataApiCall,
} from "../../helpers/fakebackend_helper";

// Get Company To User List Saga

function* getCompanyToUserListSaga() {
  try {
    const response = yield call(getCompanyToUserListApiCall);
    yield put(getCompanyToUserListSuccess(response));
  } catch (error) {
    yield put(getCompanyToUserListFailure(error));
  }
}

function* watchGetCompanyToUserListSaga() {
  yield takeEvery(GET_COMPANY_TO_USER_LIST, getCompanyToUserListSaga);
}

// Switch Company Saga

function* switchCompanySaga(action) {
  try {
    const response = yield call(switchCompanyApiCall, action.payload);

    yield put(switchCompanySuccess(response));
  } catch (error) {
    yield put(switchCompanyFailure(error));
  }
}

function* watchSwitchCompanySaga() {
  yield takeEvery(SWITCH_COMPANY, switchCompanySaga);
}

// Get Company User Invitations List
function* getCompanyUserInvitationsSaga() {
  try {
    const response = yield call(getCompanyUserInvitationsApiCall);
    yield put(getCompanyUserInvitationsSuccess(response));
  } catch (error) {
    yield put(getCompanyUserInvitationsFailure(error));
  }
}

function* watchGetCompanyUserInvitationsSaga() {
  yield takeEvery(GET_COMPANY_USER_INVITATIONS, getCompanyUserInvitationsSaga);
}

// Send USER Email Invitation
function* sendEmailInvitationSaga(action) {
  try {
    const response = yield call(sendEmailInvitationApiCall, action.payload);
    yield put(sendEmailInvitationSuccess(response));
  } catch (error) {
    yield put(sendEmailInvitationFailure(error));
  }
}

function* watchSendEmailInvitationSaga() {
  yield takeEvery(SEND_EMAIL_INVITATION, sendEmailInvitationSaga);
}

// Get Join Company Invitation List
function* getJoinCompanyInvitationListSaga() {
  try {
    const response = yield call(getJoinCompanyInvitationListApiCall);
    yield put(getJoinCompanyInvitationListSuccess(response));
  } catch (error) {
    yield put(getJoinCompanyInvitationListFailure(error));
  }
}

function* watchGetJoinCompanyInvitationListSaga() {
  yield takeEvery(
    GET_JOIN_COMPANY_INVITATION_LIST,
    getJoinCompanyInvitationListSaga
  );
}

// Accept Or Decline Invitation To Join Company
function* acceptOrDeclineInvitationToJoinCompanySaga(action) {
  try {
    const response = yield call(
      acceptOrDeclineInvitationToJoinCompanyApiCall,
      action.payload
    );
    yield put(acceptOrDeclineInvitationToJoinCompanySuccess(response));
  } catch (error) {
    yield put(acceptOrDeclineInvitationToJoinCompanyFailure(error));
  }
}

function* watchAcceptOrDeclineInvitationToJoinCompanySaga() {
  yield takeEvery(
    ACCEPT_OR_DECLINE_INVITATION_TO_JOIN_COMPANY,
    acceptOrDeclineInvitationToJoinCompanySaga
  );
}

// Get Company Team Members List
function* getCompanyTeamMembersListSaga() {
  try {
    const response = yield call(getCompanyTeamMembersListApiCall);
    yield put(getCompanyTeamMembersListSuccess(response));
  } catch (error) {
    yield put(getCompanyTeamMembersListFailure(error));
  }
}

function* watchGetCompanyTeamMembersListSaga() {
  yield takeEvery(GET_COMPANY_TEAM_MEMBERS_LIST, getCompanyTeamMembersListSaga);
}

// Get Company Details
function* getCompanyDetailsSaga(action) {
  try {
    const response = yield call(getCompanyDetailsApiCall, action.payload);
    yield put(getCompanyDetailsSuccess(response));
  } catch (error) {
    yield put(getCompanyDetailsFailure(error));
  }
}

function* watchGetCompanyDetailsSaga() {
  yield takeEvery(GET_COMPANY_DETAILS, getCompanyDetailsSaga);
}

// Update Company Details
function* updateCompanyDetailsSaga(action) {
  try {
    const response = yield call(updateCompanyDetailsApiCall, action.payload);
    yield put(updateCompanyDetailsSuccess(response));
  } catch (error) {
    yield put(updateCompanyDetailsFailure(error));
  }
}

function* watchUpdateCompanyDetailsSaga() {
  yield takeEvery(UPDATE_COMPANY_DETAILS, updateCompanyDetailsSaga);
}

// Get User Available Menu
function* getUserAvailableMenuSaga() {
  try {
    const response = yield call(getUserAvailableMenuApiCall);
    yield put(getUserAvailableMenuSuccess(response));
  } catch (error) {
    yield put(getUserAvailableMenuFailure(error));
  }
}

function* watchGetUserAvailableMenuSaga() {
  yield takeEvery(GET_USER_AVAILABLE_MENU, getUserAvailableMenuSaga);
}

// Get User Available Dashboard
function* getUserAvailableDashboardSaga() {
  try {
    const response = yield call(getUserAvailableDashboardApiCall);
    yield put(getUserAvailableDashboardSuccess(response));
  } catch (error) {
    yield put(getUserAvailableDashboardFailure(error));
  }
}

function* watchGetUserAvailableDashboardSaga() {
  yield takeEvery(GET_USER_AVAILABLE_DASHBOARD, getUserAvailableDashboardSaga);
}

// Map Dashboard And Menu To User
function* mapDashboardAndMenuToUserSaga(action) {
  try {
    const response = yield call(
      mapDashboardAndMenuToUserApiCall,
      action.payload
    );
    yield put(mapDashboardAndMenuToUserSuccess(response));
  } catch (error) {
    yield put(mapDashboardAndMenuToUserFailure(error));
  }
}

function* watchMapDashboardAndMenuToUserSaga() {
  yield takeEvery(
    MAP_DASHBOARD_AND_MENU_TO_USER,
    mapDashboardAndMenuToUserSaga
  );
}

// Get Company To User List Team Saga
function* getCompanyToUserListTeamSaga() {
  try {
    const response = yield call(getCompanyToUserListTeamApiCall);
    yield put(getCompanyToUserListTeamSuccess(response));
  } catch (error) {
    yield put(getCompanyToUserListTeamFailure(error));
  }
}

function* watchGetCompanyToUserListTeamSaga() {
  yield takeEvery(GET_COMPANY_TO_USER_LIST_TEAM, getCompanyToUserListTeamSaga);
}

// Update Company To User Team Saga
function* updateCompanyToUserTeamSaga(action) {
  try {
    const response = yield call(updateCompanyToUserTeamApiCall, action.payload);
    yield put(updateCompanyToUserTeamSuccess(response));
  } catch (error) {
    yield put(updateCompanyToUserTeamFailure(error));
  }
}

function* watchUpdateCompanyToUserTeamSaga() {
  yield takeEvery(UPDATE_COMPANY_TO_USER_TEAM, updateCompanyToUserTeamSaga);
}

// Create Company To User Saga
function* createCompanyToUserSaga(action) {
  try {
    const response = yield call(createCompanyToUserApiCall, action.payload);
    yield put(createCompanyToUserSuccess(response));
  } catch (error) {
    yield put(createCompanyToUserFailure(error));
  }
}

function* watchCreateCompanyToUserSaga() {
  yield takeEvery(CREATE_COMPANY_TO_USER, createCompanyToUserSaga);
}

// Delete Company To User Saga
function* deleteCompanyToUserSaga(action) {
  try {
    const response = yield call(deleteCompanyToUserApiCall, action.payload);
    yield put(deleteCompanyToUserSuccess(response));
  } catch (error) {
    yield put(deleteCompanyToUserFailure(error));
  }
}

function* watchDeleteCompanyToUserSaga() {
  yield takeEvery(DELETE_COMPANY_TO_USER, deleteCompanyToUserSaga);
}

// Lock User Saga
function* companyToUserLockUserSaga(action) {
  try {
    const response = yield call(companyToUserLockUserApiCall, action.payload);
    yield put(companyToUserLockUserSuccess(response));
  } catch (error) {
    yield put(companyToUserLockUserFailure(error));
  }
}

function* watchCompanyToUserLockUserSaga() {
  yield takeEvery(COMPANY_TO_USER_LOCK_USER, companyToUserLockUserSaga);
}

// Unlock User Saga
function* companyToUserUnlockUserSaga(action) {
  try {
    const response = yield call(companyToUserUnlockUserApiCall, action.payload);
    yield put(companyToUserUnlockUserSuccess(response));
  } catch (error) {
    yield put(companyToUserUnlockUserFailure(error));
  }
}

function* watchCompanyToUserUnlockUserSaga() {
  yield takeEvery(COMPANY_TO_USER_UNLOCK_USER, companyToUserUnlockUserSaga);
}

// Reset Password Saga
function* companyToUserResetPasswordSaga(action) {
  try {
    const response = yield call(
      companyToUserResetPasswordApiCall,
      action.payload
    );
    yield put(companyToUserResetPasswordSuccess(response));
  } catch (error) {
    yield put(companyToUserResetPasswordFailure(error));
  }
}

function* watchCompanyToUserResetPasswordSaga() {
  yield takeEvery(
    COMPANY_TO_USER_RESET_PASSWORD,
    companyToUserResetPasswordSaga
  );
}

// Update Subscription Licence And Security Saga
function* companyToUserUpdateSubscriptionLicenceAndSecuritySaga(action) {
  try {
    const response = yield call(
      companyToUserUpdateSubscriptionLicenceAndSecurityApiCall,
      action.payload
    );
    yield put(
      companyToUserUpdateSubscriptionLicenceAndSecuritySuccess(response)
    );
  } catch (error) {
    yield put(companyToUserUpdateSubscriptionLicenceAndSecurityFailure(error));
  }
}

function* watchCompanyToUserUpdateSubscriptionLicenceAndSecuritySaga() {
  yield takeEvery(
    COMPANY_TO_USER_UPDATE_SUBSCRIPTION_LICENCE_AND_SECURITY,
    companyToUserUpdateSubscriptionLicenceAndSecuritySaga
  );
}

// Get Company To User Data Saga
function* getCompanyToUserDataSaga(action) {
  try {
    const response = yield call(getCompanyToUserDataApiCall, action.payload);
    yield put(getCompanyToUserDataSuccess(response));
  } catch (error) {
    yield put(getCompanyToUserDataFailure(error));
  }
}

function* watchGetCompanyToUserDataSaga() {
  yield takeEvery(GET_COMPANY_TO_USER_DATA, getCompanyToUserDataSaga);
}

// Export all saga functions

export default function* CompanyToUser() {
  yield all([
    call(watchGetCompanyToUserListSaga),
    call(watchSwitchCompanySaga),
    call(watchGetCompanyUserInvitationsSaga),
    call(watchSendEmailInvitationSaga),
    call(watchGetJoinCompanyInvitationListSaga),
    call(watchAcceptOrDeclineInvitationToJoinCompanySaga),
    call(watchGetCompanyTeamMembersListSaga),
    call(watchGetCompanyDetailsSaga),
    call(watchUpdateCompanyDetailsSaga),
    call(watchGetUserAvailableMenuSaga),
    call(watchGetUserAvailableDashboardSaga),
    call(watchMapDashboardAndMenuToUserSaga),
    call(watchGetCompanyToUserListTeamSaga),
    call(watchUpdateCompanyToUserTeamSaga),
    call(watchCreateCompanyToUserSaga),
    call(watchDeleteCompanyToUserSaga),
    call(watchCompanyToUserLockUserSaga),
    call(watchCompanyToUserUnlockUserSaga),
    call(watchCompanyToUserResetPasswordSaga),
    call(watchCompanyToUserUpdateSubscriptionLicenceAndSecuritySaga),
    call(watchGetCompanyToUserDataSaga),
  ]);
}
